import styled from '@emotion/styled';
import CircularProgress from '@material-ui/core/CircularProgress';

import COLORS from '$variables/colors';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  align-items: center;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  padding: 0;
  @media (max-width: 600px) {
    height: 100%;
  }
`;

export const StyledCircularProgress = styled(CircularProgress)`
  color: ${COLORS.blue};
`;
